<ecp-hero title="Return Request Status" image="assets/images/headers/experts.jpg"> </ecp-hero>

<div class="container mt-30">
  <div class="row is-flex">
    <ng-container *ngIf="(frameReturns$ | async).length === 0; else frameReturns">
      <div class="col is-flex is-fullwidth" *ngIf="user$ | async">
        <div class="container">
          No return requests found.
        </div>
      </div>
    </ng-container>
    <ng-template #frameReturns>
      <div class="col is-flex is-fullwidth">
        <div class="container">
          <ecp-returns-status-details
            [returns]="frameReturns$ | async | searchList: searchTerm"
          ></ecp-returns-status-details>
        </div>
      </div>
    </ng-template>
  </div>
</div>
